import { jsx as i, jsxs as Ee } from "react/jsx-runtime";
import { useRef as Le, useMemo as N, useEffect as T } from "react";
import Te from "../../../make-cancellable-promise/dist/esm/index.es.js";
import he from "../../../make-event-props/dist/esm/index.es.js";
import { clsx as ve } from "../../../clsx/dist/clsx.es.js";
import Ge from "../../../merge-refs/dist/esm/index.es.js";
import ne from "../../../tiny-invariant/dist/esm/tiny-invariant.es.js";
import be from "../../../warning/warning.es.js";
import Ae from "./PageContext.es.js";
import j from "./Message.es.js";
import we from "./Page/Canvas.es.js";
import _e from "./Page/TextLayer.es.js";
import Oe from "./Page/AnnotationLayer.es.js";
import { isProvided as u, cancelRunningTask as Ce, makePageCallback as te } from "./shared/utils.es.js";
import ke from "./shared/hooks/useDocumentContext.es.js";
import Ne from "./shared/hooks/useResolver.es.js";
var je = function(a, y) {
  var d = {};
  for (var r in a) Object.prototype.hasOwnProperty.call(a, r) && y.indexOf(r) < 0 && (d[r] = a[r]);
  if (a != null && typeof Object.getOwnPropertySymbols == "function")
    for (var t = 0, r = Object.getOwnPropertySymbols(a); t < r.length; t++)
      y.indexOf(r[t]) < 0 && Object.prototype.propertyIsEnumerable.call(a, r[t]) && (d[r[t]] = a[r[t]]);
  return d;
};
const oe = 1;
function Ye(a) {
  const y = ke(), d = Object.assign(Object.assign({}, y), a), { _className: r = "react-pdf__Page", _enableRegisterUnregisterPage: t = !0, canvasBackground: h, canvasRef: ae, children: se, className: ce, customRenderer: $, customTextRenderer: D, devicePixelRatio: M, error: v = "Failed to load the page.", height: R, inputRef: ie, loading: G = "Loading page…", noData: b = "No page specified.", onGetAnnotationsError: I, onGetAnnotationsSuccess: F, onGetStructTreeError: W, onGetStructTreeSuccess: B, onGetTextError: U, onGetTextSuccess: V, onLoadError: H, onLoadSuccess: J, onRenderAnnotationLayerError: K, onRenderAnnotationLayerSuccess: q, onRenderError: z, onRenderSuccess: Q, onRenderTextLayerError: X, onRenderTextLayerSuccess: Y, pageIndex: f, pageNumber: m, pdf: s, registerPage: Z, renderAnnotationLayer: ue = !0, renderForms: ee = !1, renderMode: de = "canvas", renderTextLayer: A = !0, rotate: w, scale: P = oe, unregisterPage: _, width: S } = d, re = je(d, ["_className", "_enableRegisterUnregisterPage", "canvasBackground", "canvasRef", "children", "className", "customRenderer", "customTextRenderer", "devicePixelRatio", "error", "height", "inputRef", "loading", "noData", "onGetAnnotationsError", "onGetAnnotationsSuccess", "onGetStructTreeError", "onGetStructTreeSuccess", "onGetTextError", "onGetTextSuccess", "onLoadError", "onLoadSuccess", "onRenderAnnotationLayerError", "onRenderAnnotationLayerSuccess", "onRenderError", "onRenderSuccess", "onRenderTextLayerError", "onRenderTextLayerSuccess", "pageIndex", "pageNumber", "pdf", "registerPage", "renderAnnotationLayer", "renderForms", "renderMode", "renderTextLayer", "rotate", "scale", "unregisterPage", "width"]), [le, g] = Ne(), { value: e, error: O } = le, C = Le(null);
  ne(s, "Attempted to load a page, but no document was specified. Wrap <Page /> in a <Document /> or pass explicit `pdf` prop.");
  const o = u(m) ? m - 1 : f ?? null, c = m ?? (u(f) ? f + 1 : null), l = w ?? (e ? e.rotate : null), n = N(() => {
    if (!e)
      return null;
    let p = 1;
    const E = P ?? oe;
    if (S || R) {
      const L = e.getViewport({ scale: 1, rotation: l });
      S ? p = S / L.width : R && (p = R / L.height);
    }
    return E * p;
  }, [R, e, l, P, S]);
  T(function() {
    return () => {
      u(o) && t && _ && _(o);
    };
  }, [t, s, o, _]);
  function pe() {
    if (J) {
      if (!e || !n)
        return;
      J(te(e, n));
    }
    if (t && Z) {
      if (!u(o) || !C.current)
        return;
      Z(o, C.current);
    }
  }
  function fe() {
    O && (be(!1, O.toString()), H && H(O));
  }
  T(function() {
    g({ type: "RESET" });
  }, [g, s, o]), T(function() {
    if (!s || !c)
      return;
    const E = Te(s.getPage(c)), L = E;
    return E.promise.then((k) => {
      g({ type: "RESOLVE", value: k });
    }).catch((k) => {
      g({ type: "REJECT", error: k });
    }), () => Ce(L);
  }, [g, s, c]), T(() => {
    if (e !== void 0) {
      if (e === !1) {
        fe();
        return;
      }
      pe();
    }
  }, [e, n]);
  const me = N(() => (
    // Technically there cannot be page without pageIndex, pageNumber, rotate and scale, but TypeScript doesn't know that
    e && u(o) && c && u(l) && u(n) ? {
      _className: r,
      canvasBackground: h,
      customTextRenderer: D,
      devicePixelRatio: M,
      onGetAnnotationsError: I,
      onGetAnnotationsSuccess: F,
      onGetStructTreeError: W,
      onGetStructTreeSuccess: B,
      onGetTextError: U,
      onGetTextSuccess: V,
      onRenderAnnotationLayerError: K,
      onRenderAnnotationLayerSuccess: q,
      onRenderError: z,
      onRenderSuccess: Q,
      onRenderTextLayerError: X,
      onRenderTextLayerSuccess: Y,
      page: e,
      pageIndex: o,
      pageNumber: c,
      renderForms: ee,
      renderTextLayer: A,
      rotate: l,
      scale: n
    } : null
  ), [
    r,
    h,
    D,
    M,
    I,
    F,
    W,
    B,
    U,
    V,
    K,
    q,
    z,
    Q,
    X,
    Y,
    e,
    o,
    c,
    ee,
    A,
    l,
    n
  ]), ge = N(
    () => he(re, () => e && (n ? te(e, n) : void 0)),
    // biome-ignore lint/correctness/useExhaustiveDependencies: FIXME
    [re, e, n]
  ), x = `${o}@${n}/${l}`;
  function ye() {
    switch (de) {
      case "custom":
        return ne($, 'renderMode was set to "custom", but no customRenderer was passed.'), i($, {}, `${x}_custom`);
      case "none":
        return null;
      case "canvas":
      default:
        return i(we, { canvasRef: ae }, `${x}_canvas`);
    }
  }
  function Re() {
    return A ? i(_e, {}, `${x}_text`) : null;
  }
  function Pe() {
    return ue ? i(Oe, {}, `${x}_annotations`) : null;
  }
  function Se() {
    return Ee(Ae.Provider, { value: me, children: [ye(), Re(), Pe(), se] });
  }
  function xe() {
    return c ? s === null || e === void 0 || e === null ? i(j, { type: "loading", children: typeof G == "function" ? G() : G }) : s === !1 || e === !1 ? i(j, { type: "error", children: typeof v == "function" ? v() : v }) : Se() : i(j, { type: "no-data", children: typeof b == "function" ? b() : b });
  }
  return i("div", Object.assign({
    className: ve(r, ce),
    "data-page-number": c,
    // Assertion is needed for React 18 compatibility
    ref: Ge(ie, C),
    style: {
      "--scale-factor": `${n}`,
      backgroundColor: h || "white",
      position: "relative",
      minWidth: "min-content",
      minHeight: "min-content"
    }
  }, ge, { children: xe() }));
}
export {
  Ye as default
};
//# sourceMappingURL=Page.es.js.map
